/** `#knowledge` — `template.html` dòng 947–973, thuộc tính `data-en`. */

interface BadgeRow {
  readonly kind: 'badge';
  readonly code: string;
  readonly tint: 'danger' | 'success' | 'brand';
  readonly label: string;
  readonly trailing: string;
}

interface IconRow {
  readonly kind: 'icon';
  readonly label: string;
  readonly trailing: string;
}

interface KnowledgeCard {
  readonly icon: 'library' | 'book-open';
  readonly iconTone: 'brand' | 'violet';
  readonly title: string;
  readonly beta: boolean;
  readonly body: string;
  readonly rows: readonly (BadgeRow | IconRow)[];
}

const cards: readonly KnowledgeCard[] = [
  {
    icon: 'library',
    iconTone: 'brand',
    title: 'Knowledge Base',
    beta: false,
    body: 'A categorised library of the documents a company actually reuses — searchable, bookmarkable, and readable by the agents you allow.',
    rows: [
      { kind: 'badge', code: 'PDF', tint: 'danger', label: 'launch-plan.pdf', trailing: '2.4 MB' },
      { kind: 'badge', code: 'XLSX', tint: 'success', label: 'qa-signoff.xlsx', trailing: '88 KB' },
      {
        kind: 'badge',
        code: 'DOCX',
        tint: 'brand',
        label: 'rollout-runbook.docx',
        trailing: '210 KB',
      },
    ],
  },
  {
    icon: 'book-open',
    iconTone: 'violet',
    title: 'Wiki',
    beta: true,
    body: 'Long-form internal documentation with a structured editor — handbooks, runbooks, decision records that outlive the chat.',
    rows: [
      { kind: 'icon', label: 'Engineering handbook', trailing: 'v12' },
      { kind: 'icon', label: 'Incident response runbook', trailing: 'v4' },
      { kind: 'icon', label: 'Q2 decision records', trailing: 'v2' },
    ],
  },
];

export const knowledge = {
  eyebrow: 'Knowledge Base & Wiki',
  heading: 'What the team knows, kept where the team works.',
  betaLabel: 'BETA',
  cards,
};
